import { onFind } from '@elements/init-modules-in-scope';
import './scripts/common';

let _config = window['_config'] || {};

let app = {
    debug: false,
};
window.app = app || {};

import * as ajaxForm from '@elements/ajax-form';
ajaxForm.init();

import Alert from 'bootstrap/js/dist/alert';
onFind('.alert',function(element){
    new Alert(element);
});

import * as filterForm from './scripts/ajax-form-animated';
filterForm.init();